import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useContext,
} from "react";
import {
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Box,
  Icon,
  Typography,
  Divider,
} from "@mui/material";
import CustomerContext from "../../../context";
import { FCol } from "../../../../../../globalComponents/standard";
import { gridFilteredSortedRowEntriesSelector } from "@mui/x-data-grid";
import TransactionHistory from "./list";

function InfiniteList({ transactions }) {
  const loaderRef = useRef(null);

  const { transactionsRequest, onTransactionsNextPage } =
    useContext(CustomerContext);

  const { page, loading, limit, totalPages, totalItems } = transactionsRequest;

  const fetchData = async () => {
    if (totalItems > transactions.length)
      onTransactionsNextPage({ page: page + 1 });
  };

  const handleObserver = useCallback(
    (entries) => {
      const target = entries[0];

      if (target.isIntersecting) {
        if (loading) return;
        if (transactions.length) {
          fetchData();
        }
      }
    },
    [loading, page],
  );

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: "20px",
      threshold: 1.0,
    };

    const observer = new IntersectionObserver(handleObserver, option);

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => observer.disconnect();
  }, [handleObserver]);

  return (
    <>
      {/* <List dense>
        {transactions.map((transaction, key) => (
          <TransactionComponent key={key} transaction={transaction} />
        ))}
      </List> */}
      <TransactionHistory transactions={transactions} />

      <Box ref={loaderRef} display="flex" justifyContent="center" p={2}>
        {loading ? (
          <CircularProgress />
        ) : !transactions.length ? (
          <EmptyComponent />
        ) : null}
      </Box>
    </>
  );
}

const TransactionComponent = React.memo(({ transaction }) => {
  const { description, createdAt, amount } = transaction;

  return (
    <React.Fragment>
      <ListItem
        style={{
          borderLeft: `5px solid ${amount < 0 ? "#8d0000" : "#2e7d32"}`,
          borderRadius: 5,
          marginTop: 2,
        }}
        secondaryAction={
          <ListItemText
            primary={
              <Typography align="end" variant="h5">
                {amount}
              </Typography>
            }
            secondary={
              <Typography
                color="textSecondary"
                style={{ textAlign: "right" }}
                align="end"
                variant="body2"
              >
                {"Pontos"}
              </Typography>
            }
          />
        }
      >
        <ListItemText primary={description} secondary={createdAt} />
      </ListItem>
      <Divider component="li" />
    </React.Fragment>
  );
});

const EmptyComponent = () => {
  return (
    <FCol justifyContent="center" marginTop={"25dvh"} fullWidth>
      <Icon
        color="disabled"
        style={{ fontSize: 96, alignSelf: "center", textAlign: "center" }}
      >
        playlist_remove
      </Icon>
      <Typography align="center" variant="h5">
        Nenhum registro encontrado
      </Typography>
    </FCol>
  );
};

export default React.memo(InfiniteList);
